import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Plus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEmail2Plus"><Path fillRule="evenodd" clipRule="evenodd" d="M22 9.11816L12 14.1182L4 10.1172V18H12V20H2V4H22V9.11816Z" fill="currentColor"/><Path d="M20 16H23V18H20V21H18V18H15V16H18V13H20V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Plus;
